export const SET_PERSONAL_FILTER = 'SET_PERSONAL_FILTER'
export const SET_ENTERPRISE_FILTER = 'SET_ENTERPRISE_FILTER'
export const SET_PROJECT_FILTER = 'SET_PROJECT_FILTER'

